// src/components/Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
//import { Logo } from './common';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-sm">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="text-gray-700 hover:text-blue-600">
              <Link to="/"><b>Qubiteers</b></Link>
          </div>

          <div className="hidden md:flex md:items-center md:space-x-8">
            <Link to="/news" className="text-gray-700 hover:text-blue-600">News</Link>
            <Link to="/community" className="text-gray-700 hover:text-blue-600">Community</Link>
            <Link to="/events" className="text-gray-700 hover:text-blue-600">Events</Link>
            <Link to="/talent" className="text-gray-700 hover:text-blue-600">Talent</Link>
            <Link to="/resources" className="text-gray-700 hover:text-blue-600">Resources</Link>
            <button className="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
              Sign In
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="space-y-1 pb-3 pt-2">
              <Link to="/news" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">News</Link>
              <Link to="/community" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Community</Link>
              <Link to="/events" className="text-gray-700 hover:text-blue-600">Events</Link>
              <Link to="/careers" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Careers</Link>
              <Link to="/resources" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Resources</Link>
              <button className="block w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
                Sign In
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;